import { Box, Typography } from '@mui/material';
import React from 'react';
import StyledBox from './styles';

interface PanelLayoutProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  badge?: React.ReactNode;
  secondaryRow?: React.ReactNode;
  children: React.ReactNode;
}

// Shared chrome for a SessionPanel tab's content (HistoryPanel/CompliancePanel):
// icon + title + count-badge header, an optional secondary row (e.g. Legend),
// and a grey scrollable content area. Only the badge's color/count and the
// content itself are consumer-specific -- everything else stays identical
// between tabs instead of drifting independently.
export default function PanelLayout(props: PanelLayoutProps) {
  const {
    icon, title, badge, secondaryRow, children,
  } = props;
  return (
    <StyledBox>
      <Box className="header">
        <Typography variant="h2">
          {icon}
          {title}
        </Typography>
        {badge}
      </Box>
      {secondaryRow}
      <Box className="content">
        {children}
      </Box>
    </StyledBox>
  );
}
